const pl = {
  // Common
  appName: 'GatherUp',
  loading: 'Ładowanie...',
  save: 'Zapisz',
  cancel: 'Anuluj',
  edit: 'Edytuj',
  delete: 'Usuń',
  submit: 'Wyślij',
  sending: 'Wysyłanie...',
  saving: 'Zapisywanie...',
  error: 'Błąd',
  success: 'Sukces',
  invite: 'Zaproś',
  unknown: 'Nieznany',
  tryAgain: 'Spróbuj ponownie',
  
  // Auth
  login: 'Zaloguj się',
  signup: 'Zarejestruj się',
  logout: 'Wyloguj się',
  email: 'Email',
  password: 'Hasło',
  confirmPassword: 'Potwierdź hasło',
  forgotPassword: 'Zapomniałeś hasła?',
  resetPassword: 'Zresetuj hasło',
  enterEmailAndPassword: 'Wprowadź email i hasło',
  invalidCredentials: 'Nieprawidłowy email lub hasło',
  welcomeBack: 'Witaj z powrotem! Wprowadź swoje dane',
  dontHaveAccount: 'Nie masz konta?',
  loginRequired: 'Musisz być zalogowany, aby utworzyć imprezę',
  goToLogin: 'Przejdź do logowania',
  
  // Navigation
  home: 'Strona główna',
  profile: 'Profil',
  friends: 'Znajomi',
  createParty: 'Utwórz imprezę',
  
  // Profile
  myProfile: 'Mój profil',
  profileInfo: 'Informacje o profilu',
  displayName: 'Nazwa wyświetlana',
  bio: 'Bio',
  location: 'Lokalizacja',
  security: 'Bezpieczeństwo',
  appearance: 'Wygląd',
  language: 'Język',
  darkMode: 'Tryb ciemny',
  lightMode: 'Tryb jasny',
  editProfile: 'Edytuj profil',
  saveChanges: 'Zapisz zmiany',
  profileUpdated: 'Profil zaktualizowany pomyślnie',
  
  // Parties
  party: 'Impreza',
  parties: 'Imprezy',
  partyDetails: 'Szczegóły imprezy',
  createNewParty: 'Utwórz nową imprezę',
  editParty: 'Edytuj imprezę',
  deleteParty: 'Usuń imprezę',
  partyName: 'Nazwa imprezy',
  partyDescription: 'Opis',
  partyDate: 'Data',
  partyTime: 'Czas',
  partyLocation: 'Lokalizacja',
  partyHost: 'Gospodarz',
  hostedBy: 'Organizowane przez',
  organizedByYou: 'Ciebie',
  attendees: 'uczestników',
  attendeesTitle: 'Uczestnicy',
  noAttendees: 'Brak uczestników',
  attending: 'Uczestniczę',
  notAttending: 'Nie uczestniczę',
  maybe: 'Może',
  rsvp: 'RSVP',
  rsvpNeeded: 'Wymagana odpowiedź',
  inviteGuests: 'Zaproś gości',
  joinParty: 'Dołącz do imprezy',
  viewDetails: 'Zobacz szczegóły',
  untitledParty: 'Impreza bez nazwy',
  noAddressProvided: 'Brak podanego adresu',
  noLocationProvided: 'Brak podanej lokalizacji',
  noLocationCoordinates: 'Nie podano współrzędnych lokalizacji',
  requestSent: 'Zaproszenie wysłane',
  youAreHosting: 'Jesteś gospodarzem',
  address: 'Adres',
  fillAllFields: 'Wypełnij wszystkie wymagane pola i wybierz lokalizację na mapie',
  mustBeLoggedIn: 'Musisz być zalogowany z prawidłowym ID użytkownika, aby utworzyć imprezę',
  clickMapToSetLocation: 'Kliknij na mapie, aby ustawić lokalizację imprezy',
  errorCreatingParty: 'Nie udało się utworzyć imprezy',
  addressNotFound: 'Nie znaleziono adresu. Spróbuj innego adresu lub kliknij na mapie.',
  errorGeocodingAddress: 'Nie udało się znaleźć adresu',
  partyCode: 'Kod imprezy',
  clickToCopyPartyCode: 'Kliknij, aby skopiować kod imprezy',
  partyCodeCopied: 'Kod imprezy skopiowany do schowka!',
  loadingPartyCode: 'Ładowanie kodu imprezy...',
  sharePartyCode: 'Udostępnij ten kod znajomym, aby dołączyli do twojej imprezy:',
  copyPartyCode: 'Kopiuj kod imprezy',
  failedToLoadPartyCode: 'Nie udało się załadować kodu imprezy',
  generateCode: "Wygeneruj kod",
  partyCodeGenerated: "Kod imprezy wygenerowany!",
  errorGeneratingCode: "Błąd podczas generowania kodu imprezy",
  
  // Items
  items: 'Przedmioty',
  itemsTitle: 'Kto co przynosi',
  addItem: 'Dodaj przedmiot',
  itemName: 'Nazwa przedmiotu',
  broughtBy: 'Przyniesione przez',
  addingItem: 'Dodawanie...',
  noItems: 'Brak dodanych przedmiotów',
  mustRSVPItems: 'Musisz potwierdzić uczestnictwo, aby dodawać przedmioty',
  
  // Home
  welcomeMessage: 'Witaj w GatherUp! Utwórz lub dołącz do imprezy, aby rozpocząć.',
  yourParties: 'Twoje imprezy',
  invitedParties: 'Imprezy, na które jesteś zaproszony',
  noHostedParties: 'Nie organizujesz jeszcze żadnych imprez.',
  noInvitedParties: 'Nie zostałeś jeszcze zaproszony na żadne imprezy.',
  getStarted: 'Rozpocznij',
  landingTitle: 'Zaplanuj swoją idealną imprezę',
  landingSubtitle: 'Twórz, organizuj i zarządzaj swoimi wydarzeniami z łatwością. Zapraszaj znajomych, śledź odpowiedzi i uczyń swoje spotkania niezapomnianymi.',
  
  // Chat
  chat: 'Czat',
  partyChat: 'Czat imprezy',
  typeMessage: 'Napisz wiadomość...',
  send: 'Wyślij',
  noMessages: 'Brak wiadomości. Rozpocznij rozmowę!',
  participants: 'uczestników',
  you: 'Ty',
  host: 'Gospodarz',
  mustRSVP: 'Musisz potwierdzić uczestnictwo, aby brać udział w czacie',
  
  // Friends
  addFriend: 'Dodaj znajomego',
  friendRequests: 'Zaproszenia do znajomych',
  pendingRequests: 'Oczekujące zaproszenia',
  yourFriends: 'Twoi znajomi',
  noFriends: 'Brak znajomych',
  noPendingRequests: 'Brak oczekujących zaproszeń',
  accept: 'Akceptuj',
  decline: 'Odrzuć',
  
  // Errors
  errorLoading: 'Błąd ładowania danych',
  errorSaving: 'Błąd zapisywania danych',
  errorSendingMessage: 'Nie udało się wysłać wiadomości',
  errorAddingItem: 'Nie udało się dodać przedmiotu',
  errorInviting: 'Nie udało się zaprosić użytkownika',
  errorRSVP: 'Nie udało się zaktualizować statusu RSVP',
  errorUploadingAvatar: 'Nie udało się przesłać zdjęcia profilowego',
  
  
  // Check-in
  checkIn: "Zamelduj się",
  checkingIn: "Aktualizacja lokalizacji...",
  updateLocation: "Aktualizuj lokalizację",
  locationUpdated: "Twoja lokalizacja została zaktualizowana!",
  locationUpdateFailed: "Nie udało się zaktualizować lokalizacji",
  checkedInSuccess: "Pomyślnie zameldowano!",
  alreadyCheckedIn: "Już zameldowałeś się na tej imprezie",
  checkedInFailed: "Nie udało się zameldować",
  checkedInHere: "zameldował(a) się tutaj",
  requestingLocation: "Proszę zezwolić na dostęp do lokalizacji po wyświetleniu monitu",
  locationPermissionDenied: "Odmowa dostępu do lokalizacji. Włącz usługi lokalizacyjne, aby się zameldować.",
  locationUnavailable: "Informacje o lokalizacji są niedostępne. Sprawdź ustawienia urządzenia.",
  locationTimeout: "Upłynął limit czasu żądania lokalizacji. Spróbuj ponownie.",
  locationError: "Nie można uzyskać Twojej lokalizacji. Spróbuj ponownie.",
  locationAccess: "Wymagany dostęp do lokalizacji",
  locationAccessInstructions: "Proszę zezwolić na dostęp do lokalizacji po wyświetleniu monitu przez przeglądarkę.",
  iOSInstructions: "Na iOS, może być konieczne naciśnięcie przycisku poniżej lub przejście do Ustawienia > Prywatność > Usługi lokalizacji",
  iOSSafariInstructions: "Safari na iOS wymaga specjalnego uprawnienia do lokalizacji. Wykonaj poniższe kroki.",
  locationTroubleshooting: "Rozwiązywanie problemów z dostępem do lokalizacji",
  checkBrowserSettings: "Sprawdź, czy Twoja przeglądarka ma uprawnienia do dostępu do Twojej lokalizacji",
  refreshAndTryAgain: "Odśwież stronę i spróbuj ponownie",
  iosGeneralSettings: "Przejdź do Ustawienia > Prywatność > Usługi lokalizacji i upewnij się, że ta aplikacja ma uprawnienia",
  safariSpecificSettings: "Przejdź do Ustawienia > Safari > Prywatność i bezpieczeństwo > Usługi lokalizacji i wybierz 'Zezwól'",
  iOSSettingsInstructions: "Jeśli nadal masz problemy, przejdź do Ustawienia > Prywatność > Usługi lokalizacji i upewnij się, że przeglądarka ma dostęp do Twojej lokalizacji.",
  tryingAgain: "Próbuję ponownie...",
  permissionGranted: "Uzyskano dostęp do lokalizacji!",
  iOSLocationPrompt: "Na iOS, może być konieczne zezwolenie na dostęp do lokalizacji w Ustawieniach",
  iOSLocationDenied: "Odmowa dostępu do lokalizacji. Na iOS, przejdź do Ustawienia > Prywatność > Usługi lokalizacji",
  locationRequired: "Wymagany dostęp do lokalizacji",
  openSettings: "Otwórz Ustawienia",
  refreshPage: "Odśwież stronę",
  afterSettingsInstructions: "Po włączeniu lokalizacji w ustawieniach, wróć do tej aplikacji i odśwież stronę",
  safariLocationInstructions: "Musisz włączyć usługi lokalizacji dla Safari. Przejdź do Ustawienia > Prywatność i bezpieczeństwo > Usługi lokalizacji > Safari i wybierz 'Zezwalaj podczas korzystania z aplikacji'.",
  iosLocationInstructions: "Musisz włączyć usługi lokalizacji dla tej przeglądarki. Przejdź do Ustawienia > Prywatność i bezpieczeństwo > Usługi lokalizacji i znajdź swoją przeglądarkę na liście.",
  httpsRequired: "Wymagane połączenie HTTPS",
  httpsRequiredExplanation: "Usługi lokalizacji wymagają bezpiecznego połączenia (HTTPS). Obecnie korzystasz z niezabezpieczonego połączenia (HTTP).",
  switchToHttps: "Przełącz na bezpieczne połączenie",
  noDateProvided: 'Nie podano daty',
  noTimeProvided: 'Nie podano godziny',
  startingAt: 'Rozpoczęcie o',
  description: 'Opis',
  yourLocation: 'Twoja lokalizacja',
  accuracy: 'Dokładność',
  meters: 'metrów',
  
  // Error handling
  somethingWentWrong: 'Coś poszło nie tak',
  errorOccurred: 'Wystąpił błąd w aplikacji.',
  goToHomepage: 'Przejdź do strony głównej',
}

export default pl; 